module.exports = __webpack_public_path__ + "img/upload.69fbeada.png";